module.exports = __webpack_public_path__ + "img/pepsico-logo-vector.7bad51b5.png";